import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  Head: {
    A_Transid: 0,
    A_Date: new Date(),
    A_Location: "",
    Loc_Name: "",
    A_Narration: "",
    A_Status: "ENTER",
    A_Confirm_Status: "ENTER",
    CreatedBy: "",
    CreatedDate: "",
    VendorName: "",
    VendorCd: "",
  },
};

const SliceVendorDiscontinueChangeRequest = createSlice({
  name: "SliceVendorDiscontinueChangeRequest",
  initialState: { value: initialState },

  reducers: {
    Head_Set: (state, action) => {
      state.value.Head = action.payload;
    },
    VendorDiscontinueChangeRequest_Init: (state) => {
      state.value = initialState;
    },
  },
});

export const { Head_Set, VendorDiscontinueChangeRequest_Init } =
  SliceVendorDiscontinueChangeRequest.actions;
export default SliceVendorDiscontinueChangeRequest.reducer;
